import {AString} from '../values/AString';
import {AStringEnum} from '../values/AStringEnum';

export class BackgroundSize extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, BackgroundSize._types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static AUTO = new AString('auto'); // TODO: Add Meta decorator
    public static CONTAIN = new AString('contain');
    public static COVER = new AString('cover');
    public static FULL_WIDTH = new AString('100% auto');
    public static FULL_HEIGHT = new AString('auto 100%');

    private static _types:Array<AString> = [
        BackgroundSize.AUTO,
        BackgroundSize.CONTAIN,
        BackgroundSize.COVER,
        BackgroundSize.FULL_WIDTH,
        BackgroundSize.FULL_HEIGHT,
    ];

    public static isAuto(sizeType:BackgroundSize):boolean
    {
        return sizeType && BackgroundSize.AUTO.isEqualTo(sizeType.value);
    }

    public static isContain(sizeType:BackgroundSize):boolean
    {
        return sizeType && BackgroundSize.CONTAIN.isEqualTo(sizeType.value);
    }

    public static isCover(sizeType:BackgroundSize):boolean
    {
        return sizeType && BackgroundSize.COVER.isEqualTo(sizeType.value);
    }

    public static isFullWidth(sizeType:BackgroundSize):boolean
    {
        return sizeType && BackgroundSize.FULL_WIDTH.isEqualTo(sizeType.value);
    }

    public static isFullHeight(sizeType:BackgroundSize):boolean
    {
        return sizeType && BackgroundSize.FULL_HEIGHT.isEqualTo(sizeType.value);
    }

    public static auto():BackgroundSize
    {
        return new BackgroundSize(BackgroundSize.AUTO);
    }

    public static contain():BackgroundSize
    {
        return new BackgroundSize(BackgroundSize.CONTAIN);
    }

    public static cover():BackgroundSize
    {
        return new BackgroundSize(BackgroundSize.COVER);
    }

    public static fullWidth():BackgroundSize
    {
        return new BackgroundSize(BackgroundSize.FULL_WIDTH);
    }

    public static fullHeight():BackgroundSize
    {
        return new BackgroundSize(BackgroundSize.FULL_HEIGHT);
    }

    public static fromString(value:string):BackgroundSize
    {
        return new BackgroundSize(AString.fromString(value));
    }
}
